const LOCAL_API_BASE = ["http://localhost", "3000/api"].join(":")

function normalizeTrailingSlash(value = "") {
  return String(value || "").replace(/\/+$/, "")
}

function isLocalFrontend() {
  if (typeof window === "undefined") return false

  const hostname = window.location.hostname

  return (
    hostname === "localhost" ||
    hostname === "127.0.0.1" ||
    hostname === "0.0.0.0"
  )
}

export const API_BASE = normalizeTrailingSlash(
  process.env.REACT_APP_API_BASE ||
    process.env.REACT_APP_API_BASE_URL ||
    process.env.REACT_APP_API_URL ||
    (isLocalFrontend() ? LOCAL_API_BASE : "/api"),
)

export const DEFAULT_USER_ID =
  "e922ef71-7119-4f8c-8b73-3c8c42629ebd"
